/* POPOSOAP evening corner. Scoped; no network, analytics SDK or personal data. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
    
    let translations = {}; try { translations = JSON.parse(root.querySelector('[data-rs-i18n]')?.textContent || '{}'); } catch {}
    const say = (key, fallback) => translations[key] || fallback;
    const abort = new AbortController();
    const on = (el, event, fn, options = {}) => el?.addEventListener(event, fn, {...options, signal: abort.signal});
    // SVG keeps directional and play marks consistent on iPhone (no emoji fallback).
    const marks = {'↗': 'm5 19 14-14M5 5h14v14', '↘': 'm5 5 14 14M5 19h14V5', '↓': 'm12 4v16m-7-7 7 7 7-7', '▶': 'm8 5 11 7-11 7Z'};
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const iconTexts = [];
    while (walker.nextNode()) if (/[↗↘↓▶]/u.test(walker.currentNode.textContent) && !walker.currentNode.parentElement.closest('script,style')) iconTexts.push(walker.currentNode);
    iconTexts.forEach(node => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/([↗↘↓▶])/u).forEach(part => {
        if (!marks[part]) { fragment.append(document.createTextNode(part)); return; }
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('class', 'rs-icon');
        svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
        svg.setAttribute('fill', part === '▶' ? 'currentColor' : 'none');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', marks[part]); path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '1.7'); path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round');
        svg.append(path); fragment.append(svg);
      });
      node.replaceWith(fragment);
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const emit = (event, values = {}) => root.dispatchEvent(new CustomEvent('poposoap:project-event', {bubbles: true, detail: {project: 'rustandseed-evening-corner', event, ...values}}));
    const asset = name => root.dataset[name] || '';
    const scenes = {
      night: {src: asset('nightImage') || 'assets/hero.webp', alt: say('k001', 'A glowing waterfall set into rocks and white pebbles, with a patio seating area and pergola behind it at dusk.'), caption: say('k002', 'Real footage · dusk, 00:10.2')},
      day: {src: asset('dayImage') || 'assets/daylight.webp', alt: say('k003', 'The same waterfall project in daylight, viewed from a closer, different angle, with water falling onto white pebbles.'), caption: say('k004', 'Same project · daylight, different angle')}
    };
    let sceneRequest = 0, moodRequest = 0;
    async function replaceImage(image, src, alt, current) {
      const next = new Image(); next.src = src;
      try { await next.decode(); } catch { return false; }
      if (!current()) return false;
      image.src = src; image.alt = alt;
      if (!reduced.matches && image.animate) image.animate([{opacity: .65}, {opacity: 1}], {duration: 180, easing: 'ease-out'});
      return true;
    }
    $$('[data-scene]').forEach(button => on(button, 'click', async () => {
      const token = ++sceneRequest, name = button.dataset.scene, scene = scenes[name];
      const ok = await replaceImage($('#rs-hero-image'), scene.src, scene.alt, () => token === sceneRequest);
      if (!ok) return;
      $$('[data-scene]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      $('#rs-hero-image').classList.toggle('is-day', name === 'day');
      $('#rs-scene-caption').textContent = scene.caption;
      emit('project_scene_select', {scene: name});
    }));
    const moods = {
      amber: {at: 10.2, src: asset('amberImage') || 'assets/mood-amber.webp', caption: say('k005', 'Warm-toned moment · 00:10.2'), alt: say('k006', 'Warm multicolored light catches the water curtain and white pebbles at dusk.')},
      violet: {at: 9.1, src: asset('violetImage') || 'assets/mood-violet.webp', caption: say('k007', 'Violet-toned moment · 00:09.1'), alt: say('k008', 'Blue and violet light glows under the spillway and across the white stones.')},
      rose: {at: 9.6, src: asset('roseImage') || 'assets/mood-rose.webp', caption: say('k009', 'Rose-toned moment · 00:09.6'), alt: say('k010', 'Rose and violet light illuminates the water curtain in the same backyard.')},
      green: {at: 11.3, src: asset('greenImage') || 'assets/mood-green.webp', caption: say('k011', 'Green-toned moment · 00:11.3'), alt: say('k012', 'Green and blue light changes across the waterfall and stones at dusk.')}
    };
    $$('[data-mood]').forEach(button => on(button, 'click', async () => {
      const token = ++moodRequest, name = button.dataset.mood, mood = moods[name];
      const ok = await replaceImage($('#rs-mood-image'), mood.src, mood.alt, () => token === moodRequest);
      if (!ok) return;
      $$('[data-mood]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      $('#rs-light-caption').textContent = mood.caption;
      $('.rs-build-final [data-film]').dataset.film = String(mood.at);
      emit('project_light_select', {mood: name});
    }));
    const film = $('#rs-film'), dialog = $('.rs-film-dialog');
    let filmRequest = 0, trigger = null, scrollLock = null;
    function lockPage() {
      if (scrollLock) return;
      const properties = ['overflow', 'position', 'top', 'left', 'right', 'width'];
      scrollLock = {y: window.scrollY, values: properties.map(name => [name, document.body.style.getPropertyValue(name), document.body.style.getPropertyPriority(name)])};
      document.body.style.overflow = 'hidden';
      Object.assign(document.body.style, {position: 'fixed', top: `-${scrollLock.y}px`, left: '0', right: '0', width: '100%'});
      document.body.classList.add('rs-project-film-open');
      queue();
    }
    function unlockPage() {
      if (!scrollLock) return;
      const saved = scrollLock; scrollLock = null;
      saved.values.forEach(([name, value, priority]) => value ? document.body.style.setProperty(name, value, priority) : document.body.style.removeProperty(name));
      const behavior = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, saved.y);
      document.documentElement.style.scrollBehavior = behavior;
      document.body.classList.remove('rs-project-film-open');
      queue();
    }
    function pauseFilm() { film.pause(); }
    $$('[data-film]').forEach(button => {
      if (!film?.dataset.src?.trim()) {
        if (button.classList.contains('rs-build-card')) { button.disabled = true; button.querySelector('.rs-small-play')?.remove(); }
        else button.hidden = true;
        return;
      }
      button.disabled = false;
      on(button, 'click', async () => {
        const token = ++filmRequest;
        trigger = button;
        lockPage(); dialog.showModal(); dialog.scrollTop = 0;
        $('.rs-film-status').textContent = '';
        if (!film.getAttribute('src')) { film.src = film.dataset.src; film.load(); }
        try {
          if (film.readyState < 1) await new Promise((resolve, reject) => {
            const clean = () => { film.removeEventListener('loadedmetadata', ready); film.removeEventListener('error', fail); clearTimeout(timer); };
            const ready = () => { clean(); resolve(); }, fail = () => { clean(); reject(new Error('media')); };
            const timer = setTimeout(fail, 30000);
            film.addEventListener('loadedmetadata', ready, {once: true}); film.addEventListener('error', fail, {once: true});
          });
          if (token !== filmRequest || !dialog.open) return;
          film.currentTime = Math.min(Number(button.dataset.film) || 0, Math.max(0, film.duration - .1));
          await film.play();
          if (token !== filmRequest || !dialog.open) pauseFilm();
          else emit('project_film_play', {start: Number(button.dataset.film) || 0});
        } catch (error) {
          if (dialog.open && token === filmRequest && error.name !== 'AbortError') $('.rs-film-status').textContent = say('k013', 'The film could not play. The project photos and original Instagram link remain available.');
        }
      });
    });
    on(film, 'playing', () => { $('.rs-film-status').textContent = ''; });
    const closeFilm = () => { ++filmRequest; pauseFilm(); dialog.close(); };
    on($('#rs-close-film'), 'click', closeFilm);
    on(dialog, 'cancel', () => { ++filmRequest; pauseFilm(); });
    on(dialog, 'click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeFilm();
    });
    on(dialog, 'close', () => { ++filmRequest; pauseFilm(); unlockPage(); trigger?.focus({preventScroll: true}); });
    on(document, 'visibilitychange', () => { if (document.hidden) pauseFilm(); });
    const form = $('#rs-plan-form'), result = $('#rs-plan-result'), key = 'poposoap:rustandseed:evening-plan:v1';
    let plan = null, downloadURL = null, downloadTimer = 0;
    const labels = {border: say('k014', 'A garden border'), patio: say('k015', 'Beside the patio'), exploring: say('k016', 'Finding the right spot'), planned: say('k017', 'Power location in mind'), unsure: say('k018', 'Power still to check'), have: say('k019', 'Existing stone'), source: say('k020', 'New stone to source')};
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '{}');
      for (const name of ['location', 'power', 'stone']) {
        const value = saved[name];
        const input = [...form.elements].find(e => e.name === name && e.value === value);
        if (input) input.checked = true;
      }
    } catch { /* Storage is optional. No personal data is stored. */ }
    function makePlan(values) {
      const items = [];
      if (values.location === 'border') items.push(say('k021', 'Measure the garden border for the actual basin and leave access to the pump. Check levels, drainage and clearance from roots.'));
      if (values.location === 'patio') items.push(say('k022', 'Measure the space beside the patio. Plan a stable basin location, keep the walking route clear and consider splash around paving.'));
      if (values.location === 'exploring') items.push(say('k023', 'Choose a corner you can enjoy from a seat or window. Measure it for the actual basin, pump access and a suitable power arrangement.'));
      items.push(values.power === 'unsure' ? say('k024', 'Resolve the power plan before buying: this kit is electric, not solar. Review the manual and arrange suitable outdoor electrical protection; get qualified help if needed.') : say('k025', 'Check your proposed outdoor power point against the manual and appropriate electrical protection. The listed cord is 9.8 ft; do not assume that settles the electrical layout.'));
      items.push(values.stone === 'have' ? say('k026', 'Check your existing stone sizes and tray load limits. Keep the pump accessible and budget separately for any additional pebbles or planting.') : say('k027', 'Choose and budget for decorative rocks, pebbles and any planting. They are not in the kit. Check tray load limits and keep service access.'));
      items.push(say('k028', 'Read the installation manual and verify the physical unit before excavation or cutting stone. Allow separate time for ground preparation, stonework and power.'));
      items.push(say('k029', 'Plan routine water-level checks and pump/filter care. Follow the manual for cleaning and cold-weather storage.'));
      return {values, summary: `${labels[values.location]} · ${labels[values.power]} · ${labels[values.stone]}`, items};
    }
    on(form, 'submit', e => {
      e.preventDefault(); if (!form.reportValidity()) return;
      const values = Object.fromEntries(new FormData(form)); plan = makePlan(values);
      $('#rs-plan-summary').textContent = plan.summary;
      const list = $('#rs-plan-items'); list.replaceChildren();
      plan.items.forEach(text => { const li = document.createElement('li'); li.textContent = text; list.append(li); });
      try { localStorage.setItem(key, JSON.stringify(values)); } catch { /* Visit-only fallback. */ }
      form.hidden = true; result.hidden = false; result.focus({preventScroll: true});
      result.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'});
      emit('project_plan_create', values);
    });
    on($('#rs-edit-plan'), 'click', () => { result.hidden = true; form.hidden = false; form.querySelector('input:checked, input').focus({preventScroll: true}); form.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'}); });
    on($('#rs-save-plan'), 'click', () => {
      if (!plan) return;
      const text = [say('k030', 'POPOSOAP — MY EVENING CORNER'), say('k031', 'Inspired by @rustandseed'), plan.summary, '', ...plan.items.map((t, i) => `${i + 1}. ${t}`), '', say('k032', 'FEATURED KIT'), '24-inch Electric Pondless Waterfall Kit with Light, 1600GPH; 63W.', say('k033', 'Decorative stone and site preparation are separate.'), say('k034', 'Listed basin: 28.5 x 10.4 x 15 inches. Not an excavation template.'), '', say('k035', 'Product: https://poposoapsolabargains.com/products/63w-1600gph-pondless-waterfall-kit-light'), say('k036', 'Manual: https://cdn.shopify.com/s/files/1/0672/1696/5932/files/P144_63W_1600GPH_Pondless_Waterfall_Kit_with_Light.pdf?v=1778157285'), say('k037', 'Creator: https://www.instagram.com/reel/DeUdkzMksuB/'), say('k038', 'Support: info@poposoapsolar.com'), '', say('k039', 'Planning guidance, not a site assessment. No installation time is established by the short film.')].join('\n');
      if (downloadURL) URL.revokeObjectURL(downloadURL);
      downloadURL = URL.createObjectURL(new Blob([text], {type: 'text/plain;charset=utf-8'}));
      const link = document.createElement('a'); link.href = downloadURL; link.download = 'POPOSOAP-my-evening-corner.txt'; document.body.append(link); link.click(); link.remove();
      $('.rs-download-status').textContent = say('k040', 'Your project list is ready. Check your browser’s downloads.');
      clearTimeout(downloadTimer); downloadTimer = setTimeout(() => { if (downloadURL) URL.revokeObjectURL(downloadURL); downloadURL = null; }, 30000);
      emit('project_plan_download');
    });
    const sticky = $('.rs-sticky'); let raf = 0;
    const viewport = window.visualViewport;
    const visible = el => {
      if (!el) return false;
      const r = el.getBoundingClientRect(), top = viewport?.offsetTop || 0;
      return r.top < top + (viewport?.height || innerHeight) && r.bottom > top;
    };
    function updateSticky() {
      raf = 0;
      const height = viewport?.height || innerHeight, top = viewport?.offsetTop || 0;
      root.style.setProperty('--rs-view-height', `${height}px`);
      root.style.setProperty('--rs-view-top', `${top}px`);
      // Only the two launchers are suppressed; native header/footer stay intact.
      document.body.classList.toggle('rs-project-reading', (innerWidth <= 760 || matchMedia('(pointer: coarse)').matches) && visible(root));
      sticky.hidden = dialog.open || !(innerWidth <= 760 && $('.rs-hero').getBoundingClientRect().bottom < top && !visible($('#rs-plan')) && !visible($('#rs-kit')) && !visible($('.rs-closing')) && !visible($('.rs-footer')) && root.getBoundingClientRect().bottom > top + height);
    }
    const queue = () => { if (!raf) raf = requestAnimationFrame(updateSticky); };
    on(window, 'scroll', queue, {passive: true}); on(window, 'resize', queue, {passive: true});
    on(window, 'orientationchange', queue); on(viewport, 'resize', queue, {passive: true}); on(viewport, 'scroll', queue, {passive: true});
    on(document, 'fullscreenchange', queue); on(film, 'webkitendfullscreen', queue); updateSticky();
    $$('.rs-product-link').forEach(a => on(a, 'click', () => emit('project_kit_click')));
    $$('.rs-faq details').forEach((detail, index) => on(detail, 'toggle', () => { if (detail.open) emit('project_faq_open', {question: index + 1}); }));
    $$('a[href^="#rs-"]').forEach(link => on(link, 'click', e => {
      const target = $(link.getAttribute('href')); if (!target) return;
      e.preventDefault(); target.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'});
      if (link.classList.contains('rs-skip')) { target.setAttribute('tabindex', '-1'); target.focus({preventScroll: true}); }
    }));
    root._rsCleanup = () => {
      unlockPage(); abort.abort(); document.body.classList.remove('rs-project-reading', 'rs-project-film-open'); cancelAnimationFrame(raf); clearTimeout(downloadTimer); ++filmRequest;
      if (downloadURL) URL.revokeObjectURL(downloadURL);
      if (dialog.open) dialog.close();
      pauseFilm();
    };
  }
  document.querySelectorAll('[data-rs-project]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-rs-project]').forEach(init));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-rs-project]').forEach(el => el._rsCleanup?.()));
})();
